import { ExecljsParameterValueType, IExceljsParameterControlType } from "@shared/components/exceljs-viewer";
import { UpdatedByModel } from "@shared/data-access/models";

export enum DynamicReportType {
  project = 'project',
  resale = 'resale',
}
export enum OPERATOR {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
}
export enum DynamicReportValueType {
  NULL = 0,
  MERGE = 1,
  NUMBER = 2,
  STRING = 3,
  DATE = 4,
  HYPERLINK = 5,
  FORMULA = 6,
  SHARED_STRING = 7,
  RICHTEXT = 8,
  BOOLEAN = 9,
  ERROR = 10,
}

export interface ICustomColumn {
  displayName: string;
  alias: string;
  column: string;
  columnType?: string;
  fieldType?: string;
  width?: number;
  isVisible?: boolean;
  isFilterable?: boolean;
  isSortable?: boolean;
  isRequired?: boolean;
  sequence?: number;
}
export interface IDynamicReportConfig {
  orderBy?: string;
  orderType?: 'ASC' | 'DESC';
  page?: number;
  limit?: number;
  combineType?: string;
}
export interface IOption {
  label: string;
  value: string;
  config?: Map<string, any>;
}
export interface IParameter {
  displayName: string;
  alias: string;
  column?: string;
  columnType?: string;
  type: IExceljsParameterControlType;
  valueType: ExecljsParameterValueType;
  value: any;
  param?: any;
  default?: any;
  options?: IOption[];
  templateRef?: string;
  isVisible?: boolean;
  isEditable?: boolean;
  operator?: OPERATOR;
  operators?: OPERATOR[];
}
export interface IDynamicReportGeneral {
  id: number;
  name: string;
  createdAt: string | Date;
  createdBy: UpdatedByModel;
  reportType: DynamicReportType;
  description: string;
  isActive?: boolean;
  isPublic?: boolean;
  customColumns?: ICustomColumn[];
  parameters?: IParameter[];
  config?: IDynamicReportConfig;
  [key: string]: any;
}

export interface IDynamicReportType {
  id: DynamicReportType;
  name: string;
  permissionSlug: string;
}
